import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';


import { NetworkHelperService } from '../../../_services/network-helper.service';
import {FORMS, API, CODFUNC, GENERALES, PAGE} from '../../../_config/strings';
import {Usuario} from '../../../_model/Usuario';
import { Cliente } from '../../../_model/Cliente';
import Swal from 'sweetalert2';
import {Subject} from 'rxjs/Subject';
import { IMyDpOptions, MyDatePicker, MyDatePickerModule } from 'mydatepicker';
import * as moment from 'moment';
import { ChatService } from '../../../_services/chat.service';

// variable utilizada en JQuery para poder obtener los documentos y utilizar For en el recorrido
declare var $: any;

@Component({
  selector: 'app-listar-orden-trabajo',
  templateUrl: './listar-orden-trabajo.component.html',
  styleUrls: ['./listar-orden-trabajo.component.scss']
})

export class ListarOrdenTrabajoComponent implements OnInit {

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  FORMS: any;
  API: any;
  GENERALES: any;
  PAGE: any;

  public usuario: Usuario = new Usuario();
  public cliente: Cliente = new Cliente();

  urlContrato = '';
  idCliente: any;
  urlProrroga = '';
  urlCompleta;
  ordenFecha;

  // array´s
  arrayOrdenes = [];

  constructor(
    private route: ActivatedRoute,
    private network: NetworkHelperService,
    private ruta: Router,
    private chat: ChatService,
  ) {
    this.idCliente = this.route.snapshot.paramMap.get('id');
    this.FORMS = FORMS;
    this.API = API;
    this.GENERALES = GENERALES;
    this.PAGE = PAGE;
    this.urlCompleta = this.ruta.url;
    this.urlProrroga = this.urlCompleta.split('/')[7] ;
    this.usuario = JSON.parse( localStorage.getItem('usuario') );
    this.route.params.take(1).subscribe((params: any) => {
      this.urlContrato = params['idContrato'];
    });
  }

  ngOnInit() {
    this.dtOptions = {
      language: {
          url: '//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json'
      },
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
          const self = this;
          // Unbind first in order to avoid any duplicate handler
          // (see https://github.com/l-lin/angular-datatables/issues/87)
          $('td', row).unbind('click');
          $('td', row).bind('click', () => {
            // this.selectedRowCliente(data);
            this.ruta.navigate(['dashboard/menuAlmacen/listarOrdenTrabajo/salidasMaterial/', data[0] ]);
          });
          return row;
      }
    };
    this.listarOrdenTrabajo();
  }

  listarOrdenTrabajo () {
    this.network.callSecureService(
      this.API.user.almacenes + '/' + this.API.user.ot + '/' + this.API.user.listar,
      'GET',
      null).subscribe((response: any) => {
        console.log( response );
        if ( response.Estatus === 200 ) {
          // this.arrayOrdenes = response.Mensaje;
          // let incrementando = 1;
          for ( const arrays of response.Mensaje ) {
            for (const ordenes of arrays.arrayOrdenes) {
              this.arrayOrdenes.push(
                ordenes
              );
            }
            if (arrays.arrayApoyo) {
              for (const apoyos of arrays.arrayApoyo) {
                this.arrayOrdenes.push(
                  apoyos
                );
              }
            }
          }
          this.ordenFecha = response.Mensaje.fecha;
          this.dtTrigger.next();
        } else {
          Swal('Atención', response.Mensaje, 'info');
        }
      }, err => {
        console.log(err);
        Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
      }
    );
  }

  /*
  selectedRowCliente (info: any) {
    this.ruta.navigate(['dashboard/menuAlmacen/listarOrdenTrabajo/salidasMaterial/', info[0] ]);
  }
  */

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/listar-orden-trabajo/listar-orden-trabajo.component.ts